import React from "react";
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { GrFormNextLink, GrFormPreviousLink  } from "react-icons/gr";
const Pagination = ({ totalItems, page, totalPages, onPageChange }) => {
  const renderPages = () => {
    const pages = [];
    const startPage = Math.max(1, page - 8);
    const endPage = Math.min(totalPages, page + 8);

    if (page > 8) {
      pages.push(
        <li className="page-item" key={1}>
          <a className="page-link" href="#" onClick={() => onPageChange(1)}>
            1
          </a>
        </li>
      );
      if (page > 9) {
        pages.push(
          <li className="page-item" key="start-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li className={`page-item ${i === page ? "active" : ""}`} key={i}>
          <a
            className="page-link"
            href="#"
            onClick={() => onPageChange(i)}
          >
            {i}
          </a>
        </li>
      );
    }

    if (page < totalPages - 8) {
      if (page < totalPages - 9) {
        pages.push(
          <li className="page-item" key="end-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li className="page-item" key={totalPages}>
          <a
            className="page-link"
            href="#"
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </a>
        </li>
      );
    }

    return pages;
  };

  return (
    <div className={Style.alignPagging}>
      <h5>Total Items: {totalItems}</h5>
      <h5>
        Showing page {page} of {totalPages}
      </h5>
      <ul className={Button.flextCenterBtn + " " + Style.pagging}>
        {page > 1 && (
          <li>
            <button type="button" onClick={() => onPageChange(page - 1)}>
              <span aria-hidden="true">
                <span className="material-icons"><GrFormPreviousLink  className={Style.lastIcon} /></span>
              </span>
            </button>
          </li>
        )}

        {renderPages()}

        {page < totalPages && (
          <li>
            <button type="button" onClick={() => onPageChange(page + 1)}>
              <span aria-hidden="true">
                <span className="material-icons"><GrFormNextLink className={Style.lastIcon} /></span>
              </span>
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Pagination;
